export const GridNames = {
  USERS_GRID: "UsersGrid",
  TENANTS_GRID: "TenantsGrid",
  EXECUTION_FLOWS_GRID: "ExecutionFlowsGrid",
  USER_TENANTS_GRID: "UserTenantsGrid",
};
